var _path, _circle, _path2, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemainder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6253 17.7083H20.8337L19.3702 16.2449C18.9733 15.848 18.7503 15.3097 18.7503 14.7484V11.4583C18.7503 8.73705 17.0111 6.42197 14.5837 5.56397V5.20833C14.5837 4.05774 13.6509 3.125 12.5003 3.125C11.3497 3.125 10.417 4.05774 10.417 5.20833V5.56397C7.98951 6.42197 6.25033 8.73705 6.25033 11.4583V14.7484C6.25033 15.3097 6.02735 15.848 5.63046 16.2449L4.16699 17.7083H9.37533M15.6253 17.7083V18.75C15.6253 20.4759 14.2262 21.875 12.5003 21.875C10.7744 21.875 9.37533 20.4759 9.37533 18.75V17.7083M15.6253 17.7083H9.37533",
    stroke: "#3F3F46",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 5,
    r: 3,
    fill: "#11C89B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6253 17.7083H20.8337L19.3702 16.2449C18.9733 15.848 18.7503 15.3097 18.7503 14.7484V11.4583C18.7503 8.73705 17.0111 6.42197 14.5837 5.56397V5.20833C14.5837 4.05774 13.6509 3.125 12.5003 3.125C11.3497 3.125 10.417 4.05774 10.417 5.20833V5.56397C7.98951 6.42197 6.25033 8.73705 6.25033 11.4583V14.7484C6.25033 15.3097 6.02735 15.848 5.63046 16.2449L4.16699 17.7083H9.37533M15.6253 17.7083V18.75C15.6253 20.4759 14.2262 21.875 12.5003 21.875C10.7744 21.875 9.37533 20.4759 9.37533 18.75V17.7083M15.6253 17.7083H9.37533",
    stroke: "#3F3F46",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 5,
    r: 3,
    fill: "#11C89B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemainder);
export default __webpack_public_path__ + "static/media/remainder.c6eca5deb7822ea3bfd817145576877d.svg";
export { ForwardRef as ReactComponent };